const API_URL = process.env.REACT_APP_API_URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

export const REACT_APP_HANGFIRE = process.env.REACT_APP_HANGFIRE
// AUTH CONTROLLER
export const AUTH_LOGIN_POSTURL = `${API_URL}/Auth/login`
export const AUTH_REFRESH_TOKEN_POSTURL = `${API_URL}/Auth/refresh-token`
export const AUTH_REGISTER_POSTURL = `${API_URL}/Auth/register`
export const AUTH_FORGOT_PASSWORD_PUTURL = `${API_URL}/Auth/forgot-password`
export const AUTH_USER_PASSWORD_PUTURL = `${API_URL}/Auth/user-password`
export const AUTH_VERIFY_POSTURL = `${API_URL}/Auth/verify`
export const AUTH_TEST_POSTURL = `${API_URL}/Auth/test`

// USERS CONTROLLER
export const USERS_GETURL = `${API_URL}/Users`
export const USERS_POSTURL = `${API_URL}/Users`
export const USERS_PUTURL = `${API_URL}/Users`
export const USERS_CREATEUSERWITHGROUP_POSTURL = `${API_URL}/Users/createuserwithgroup`
export const USERS_UPDATENOSISUSER_POSTURL = `${API_URL}/Users/updatenosisuser`
export const USERS_UPDATEUSERQUESTIONS_POSTURL = `${API_URL}/Users/updateuserquestions`
export const USERS_UPDATEUSERINFO_POSTURL = `${API_URL}/Users/updateuserinfo`
export const USERS_LOOKUPS_GETURL = `${API_URL}/Users/lookups`
export const USERS_BY_ID_GETURL = (id: number) => {
  return `${API_URL}/Users/${id}`
}
export const USERS_BY_USERID_GETURL = (id: number) => {
  return `${API_URL}/Users/getuserbyid/${id}`
}
export const USERQUESTIONS_BY_ID_GETURL = (id: number) => {
  return `${API_URL}/Users/getuserquestionsbyid/${id}`
}
export const USERS_BY_ID_DELETEURL = (id: number) => {
  return `${API_URL}/Users/${id}`
}

export const USERS_CURRENT_USER_GETURL = `${API_URL}/Users/currentUser`

export const COURSES_BY_ID_GETURL = `${API_BASE_URL}/Courses/get`
export const COURSE_PATIENT_INFO_BY_COURSEID_GETURL = (id: number) => {
  return `${API_BASE_URL}/Courses/GetCoursePatientInfoByCourseId/${id}`
}
export const GET_COURSE_STATUS_BY_USERID_GETURL = (id: number) => {
  return `${API_BASE_URL}/Courses/GetCourseStatusByUserId/${id}`
}

export const GET_COURSE_BATCH_RESULT_GETURL = `${API_BASE_URL}/Courses/GetCourseBatchResult`

//export const GET_COURSE_EXCEL_RESULT_GETURL = `${API_BASE_URL}/Courses/getCourseResultExcel`

export const GET_COURSE_EXCEL_RESULT_GETURL = (type: number) => {
  //1 = genel bilgiler , 2 = test sonuc, 3 = Günlük sigara kullanımı
  return `${API_BASE_URL}/Courses/getCourseResultExcel?type=${type}`
}

export const USER_CONTENT_APPLICATIONS_POSTURL = `${API_BASE_URL}/UserContentApplications`

export const USER_TEST_APPLICATIONS_POSTURL = `${API_BASE_URL}/UserTestApplications`

export const TESTS_BY_ID_GETURL = (id: number) => {
  return `${API_BASE_URL}/Tests/getById?id=${id}`
}

export const PATIENT_USAGE_GETURL = `${API_BASE_URL}/UserCigaretteUsages/getPatientUsage`

export const USER_CIGARETTE_USAGE_POSTURL = `${API_BASE_URL}/UserCigaretteUsages/`

// APPOINTMENTS CONTROLLER
export const APPOINTMENTS_BY_EXPERTID_GETURL = (id: number) => {
  return `${API_BASE_URL}/Appointments/getbyexpertId/${id}`
}
export const APPOINTMENTS_BY_PATIENTID_GETURL = (id: number) => {
  return `${API_BASE_URL}/Appointments/getbypatientId/${id}`
}
export const APPOINTMENTS_BY_ID_DELETEURL = (id: number) => {
  return `${API_BASE_URL}/Appointments/${id}`
}
export const APPOINTMENT_EXCEL_RESULT_GETURL = (appointmentDate: Date) => {
  return `${API_BASE_URL}/Appointments/getappointmentexcelresult/${appointmentDate}`
}
export const APPOINTMENT_ALLUSER_EXCEL_RESULT_GETURL = (id: number) => {
  return `${API_BASE_URL}/Appointments/getallappointmentuserdetailexcelresult/${id}`
}
export const APPOINTMENTS_UPDATE_PUTURL = `${API_BASE_URL}/Appointments`
export const APPOINTMENTS_CREATE_APPOINTMENT_POSTURL = `${API_BASE_URL}/Appointments/createAppointment`
export const APPOINTMENTS_CREATE_USER_APPOINTMENT_POSTURL = `${API_BASE_URL}/Appointments/createuserappointment`
export const APPOINTMENTGROUPS_BY_DATE_GETURL = `${API_BASE_URL}/Appointments/getappointmentgroupsbydate`

//USERGROUPS CONTROLLER
export const USERGROUPS_GETUSERSINGROUP = (id: number) => {
  return `${API_URL}/user-groups/groups/${id}/users`
}
export const USERGROUPS_GETUSERSINGROUPLIST = (ids: string) => {
  return `${API_URL}/user-groups/groups/users/${ids}`
}
export const USERGROUPS_GETUSERGROUPBYUSERID = (id: number) => {
  return `${API_URL}/user-groups/users/${id}/groups`
}

//USERCLAIMS CONTROLLER
export const USERCLAIMS_GETOPERATIONCLAIMSBYUSERID = (id: number) => {
  return `${API_URL}/user-claims/users/${id}`
}

//GROUPCLAIMS CONTROLLER
export const GROUPCLAIMS_GETGROUPOPERATIONCLAIMSBYUSERID = (id: number) => {
  return `${API_URL}/group-claims/groups/users/${id}`
}

//RESTRICTEDAPPOINTMENTDATES CONTROLLER
export const RESTRICTEDAPPOINTMENTDATE_GETBYID_URL = (id: number) => {
  return `${API_BASE_URL}/RestrictedAppointmentDates/getbyid/${id}`
}
export const RESTRICTEDAPPOINTMENTDATE_GETALL_URL = () => {
  return `${API_BASE_URL}/RestrictedAppointmentDates/getall`
}
export const RESTRICTEDAPPOINTMENTDATE_DELETE_URL = (id: number) => {
  return `${API_BASE_URL}/RestrictedAppointmentDates/${id}`
}
export const RESTRICTEDAPPOINTMENTDATE_CREATE_POSTURL = `${API_BASE_URL}/RestrictedAppointmentDates/createrestriction`
export const RESTRICTEDAPPOINTMENTDATE_UPDATE_PUTURL = `${API_BASE_URL}/RestrictedAppointmentDates`

//SBPQUESTIONS CONTROLLER
export const SBPQUESTION_GETBYID_URL = (id: number) => {
  return `${API_BASE_URL}/SBPQuestions/getSBPQuestionsById/${id}`
}
export const SBPQUESTION_SAVE_POSTURL = `${API_BASE_URL}/SBPQuestions/saveSBPQuestions`

//APPOINTMENTDETAILS CONTROLLER
export const APPOINTMENTDETAILS_BY_ID_GETURL = (id: number) => {
  return `${API_BASE_URL}/AppointmentDetails/getbyid/${id}`
}
export const APPOINTMENTDETAILS_UPDATE_PUTURL = `${API_BASE_URL}/AppointmentDetails`
export const APPOINTMENTDETAILS_CREATE_APPOINTMENTDETAILS_POSTURL = `${API_BASE_URL}/AppointmentDetails/createAppointmentDetails`
export const APPOINTMENTDETAILS_SAVE_APPOINTMENTDETAILS_POSTURL = `${API_BASE_URL}/AppointmentDetails/saveAppointmentDetails`

//APPOINTMENTQUESTIONS CONTROLLER
export const APPOINTMENTQUESTIONS_BY_ID_GETURL = (id: number) => {
  return `${API_BASE_URL}/AppointmentQuestions/getQuestionsByAppointmentId/${id}`
}
export const APPOINTMENTQUESTIONS_EXCEL_RESULT_GETURL = (appointmentId: number, type: number) => {
  return `${API_BASE_URL}/AppointmentQuestions/getappointmentquestionexcelresult/${appointmentId}/${type}`
}
export const APPOINTMENTQUESTIONS_SAVE_POSTURL = `${API_BASE_URL}/AppointmentQuestions/saveAppointmentQuestions`

//APPOINTMENTQUESTIONS CONTROLLER
export const APPOINTMENTCOQUESTIONS_BY_ID_GETURL = (id: number) => {
  return `${API_BASE_URL}/AppointmentCOQuestions/getCOQuestionsByAppointmentId/${id}`
}
// export const APPOINTMENTCOQUESTIONS_EXCEL_RESULT_GETURL = (appointmentId: number, type: number) => {
//   return `${API_BASE_URL}/AppointmentCOQuestions/getappointmentquestionexcelresult/${appointmentId}/${type}`
// }
export const APPOINTMENTCOQUESTIONS_SAVE_POSTURL = `${API_BASE_URL}/AppointmentCOQuestions/saveAppointmentCOQuestions`